/* =========================================================
   TELEPASS GRAB&GO THEME — Cart JS
   Shopify Cart AJAX API integration
   ========================================================= */

// === UPDATE CART BADGE COUNTS ===
function updateCartBadges() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var count = cart.item_count;
      var badges = document.querySelectorAll('.js-cart-count');
      badges.forEach(function(badge) {
        badge.innerText = count;
        badge.style.display = count > 0 ? 'flex' : 'none';
      });
    })
    .catch(function() {});
}

// === ADD TO CART ===
function addToCart(variantId, quantity) {
  if (!variantId) return Promise.reject('No variant ID');
  quantity = quantity || 1;

  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{ id: parseInt(variantId), quantity: quantity }]
    })
  })
  .then(function(r) {
    if (!r.ok) throw new Error('Error adding to cart');
    return r.json();
  })
  .then(function(data) {
    updateCartBadges();
    return data;
  });
}

// === ADD TO CART FORM HANDLER ===
document.addEventListener('DOMContentLoaded', function() {
  var addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

  addToCartForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var btn = form.querySelector('[type="submit"]');
      var variantInput = form.querySelector('[name="id"]');
      var quantityInput = form.querySelector('[name="quantity"]');

      if (!btn || !variantInput) return;

      var variantId = variantInput.value;
      var quantity = quantityInput ? parseInt(quantityInput.value) : 1;
      var originalText = btn.innerHTML;

      btn.disabled = true;
      btn.innerHTML = '<span class="material-symbols-outlined">hourglass_empty</span> AGGIUNTA IN CORSO...';

      addToCart(variantId, quantity)
        .then(function() {
          btn.innerHTML = '<span class="material-symbols-outlined">check_circle</span> AGGIUNTO AL CARRELLO';
          btn.style.backgroundColor = '#c4aa00';

          setTimeout(function() {
            btn.disabled = false;
            btn.innerHTML = originalText;
            btn.style.backgroundColor = '';
          }, 2500);
        })
        .catch(function(err) {
          console.error('Cart error:', err);
          btn.innerHTML = '<span class="material-symbols-outlined">error</span> ERRORE';
          setTimeout(function() {
            btn.disabled = false;
            btn.innerHTML = originalText;
          }, 2000);
        });
    });
  });

  // Initial badge count
  updateCartBadges();
});
